import type { SmtpAccount } from '@/api/types';

export type MailboxFormState = {
  label: string;
  from_email: string;
  smtp_host: string;
  smtp_port: string;
  smtp_user: string;
  smtp_password: string;
  imap_host: string;
  imap_user: string;
  imap_password: string;
};

export const emptyMailboxForm = (): MailboxFormState => ({
  label: '',
  from_email: '',
  smtp_host: '',
  smtp_port: '587',
  smtp_user: '',
  smtp_password: '',
  imap_host: '',
  imap_user: '',
  imap_password: '',
});

export function mailboxFormFromAccount(acc: SmtpAccount): MailboxFormState {
  return {
    label: acc.label,
    from_email: acc.from_email,
    smtp_host: acc.smtp_host,
    smtp_port: String(acc.smtp_port),
    smtp_user: acc.smtp_user,
    smtp_password: '',
    imap_host: acc.imap_host ?? '',
    imap_user: acc.imap_user ?? '',
    imap_password: '',
  };
}

export function buildCreateBody(projectId: string, form: MailboxFormState) {
  return {
    project_id: projectId,
    label: form.label,
    from_email: form.from_email,
    smtp_host: form.smtp_host,
    smtp_port: Number(form.smtp_port) || 587,
    smtp_secure: Number(form.smtp_port) === 465,
    smtp_user: form.smtp_user,
    smtp_password: form.smtp_password,
    imap_host: form.imap_host || null,
    imap_port: 993,
    imap_user: form.imap_user || null,
    imap_password: form.imap_password || null,
  };
}

export function buildUpdateBody(form: MailboxFormState, editing: SmtpAccount) {
  const body: Record<string, unknown> = {
    label: form.label,
    from_email: form.from_email,
    smtp_host: form.smtp_host,
    smtp_port: Number(form.smtp_port) || 587,
    smtp_secure: Number(form.smtp_port) === 465,
    smtp_user: form.smtp_user,
    imap_host: form.imap_host || null,
    imap_user: form.imap_user || null,
  };
  if (form.smtp_password.trim()) body.smtp_password = form.smtp_password;
  if (form.imap_password.trim()) body.imap_password = form.imap_password;
  if (!form.imap_host.trim()) {
    body.imap_host = null;
    body.imap_user = null;
  }
  if (editing.has_imap && !form.imap_password.trim() && form.imap_host.trim()) {
    // keep existing imap password on server
  }
  return body;
}
